import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import Image from 'gatsby-image'

import LockSVG from 'assets/images/icons/ic-lock.svg'

import { icon as iconStyle, lock } from './CardIcon.module.scss'

export type SupportedCardType = 'mastercard' | 'visa' | 'amex'

interface CardIconProps {
  cardType: SupportedCardType | ''
  className?: string
}

const query = graphql`
  {
    mastercard: file(name: { eq: "mastercard" }) {
      childImageSharp {
        fluid(maxHeight: 50) {
          ...GatsbyImageSharpFluid_withWebp_noBase64
        }
      }
    }
    visa: file(name: { eq: "visa" }) {
      childImageSharp {
        fluid(maxHeight: 50) {
          ...GatsbyImageSharpFluid_withWebp_noBase64
        }
      }
    }
    amex: file(name: { eq: "amex" }) {
      childImageSharp {
        fluid(maxHeight: 50) {
          ...GatsbyImageSharpFluid_withWebp_noBase64
        }
      }
    }
  }
`

const CardIcon = ({ cardType = '', className = '' }: CardIconProps) => {
  const { mastercard, visa, amex } = useStaticQuery<{
    mastercard: EF.LocalFluidImage
    visa: EF.LocalFluidImage
    amex: EF.LocalFluidImage
  }>(query)
  const icons: { [key: string]: EF.LocalFluidImage } = {
    mastercard,
    visa,
    amex,
    'american express': amex,
  }
  const icon = icons[cardType.toLowerCase()]

  if (!icon)
    return (
      <div className={className} data-card-type="">
        <img src={LockSVG} alt="" role="presentation" className={lock} />
      </div>
    )

  return (
    <div className={className} data-card-type={cardType}>
      <div className={iconStyle}>
        <Image fluid={icon.childImageSharp.fluid} alt={cardType} />
      </div>
    </div>
  )
}

export default CardIcon
